import React from 'react';
import './Gewichtsberechnung.css';
import { calculateGewichtStreben, calculateKulissengewicht, calculateLaengeStreben, calculateMasseKulissenrahmen, calculateMasseLochblech, calculateMasseMineralwolle, calculateMasseResonanzblech, calculateMasseStreben, calculateRKulissenblech, calculateRohdichteMineralwolle, calculateVolumenMineralwolle } from '../calculations/weight';

class Kulissengewichtberechnung extends React.Component {
    //Ermittelt die Masse einer Kulisse in KG

  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }

  _kulissengewicht(){
    return calculateKulissengewicht(this.props);
  }

  //Masse Mineralwolle
  _Masse_Mineralwolle() {
      return calculateMasseMineralwolle(this.props);
  }
  _Volumen_Mineralwolle() {
      return calculateVolumenMineralwolle(this.props);
  }
  _Rohdiche_Mineralwolle(){
      return calculateRohdichteMineralwolle();
  }
  //Masse Kulissenrahmen
    _Masse_Kulissenrahmen(){
      return calculateMasseKulissenrahmen(this.props);
    }

    _R_KBlech(){
         return calculateRKulissenblech(this.props);
    }

    //Masse Streben
    _Masse_Streben(){
        return calculateMasseStreben(this.props);
    }
    _Laenge_Streben(){
        return calculateLaengeStreben(this.props);
    }
    _Gewicht_Streben(){
      return calculateGewichtStreben();
    }

    //Masse des Resonanzbleches einseitig
    _Masse_Resonanzblech(){
      return calculateMasseResonanzblech(this.props);
    }

    _Masse_Lochblech(){
      return calculateMasseLochblech(this.props);
    }
  render() {
      // console.log("Kulissengewicht: " + this._kulissengewicht());
      this.props.handlekulissengewichtChange(this._kulissengewicht());
      return null;//(this._Masse_Mineralwolle());
  }
}
export default Kulissengewichtberechnung;
